
import { useScrollAnimation, useStaggerAnimation } from '../../../hooks/useScrollAnimation';

export default function Founder() {
  const highlights = [
    { icon: 'ri-settings-3-line', text: 'Systems thinking and operational design' },
    { icon: 'ri-cpu-line', text: 'AI implementation, not experimentation' },
    { icon: 'ri-bar-chart-grouped-line', text: 'Focus on measurable efficiency gains' },
    { icon: 'ri-checkbox-circle-line', text: 'Structured execution and delivery' }
  ];

  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: imageRef, isVisible: imageVisible } = useScrollAnimation({ threshold: 0.2 });
  const { ref: bioRef, isVisible: bioVisible } = useScrollAnimation({ threshold: 0.2 });
  const { ref: cardsRef, getItemStyle } = useStaggerAnimation(highlights.length, { threshold: 0.1 });

  return (
    <section id="about" className="bg-white py-16 md:py-28">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8">
        <div
          ref={headerRef}
          className="text-center mb-10 md:mb-14"
          style={{
            opacity: headerVisible ? 1 : 0,
            transform: headerVisible ? 'translateY(0)' : 'translateY(32px)',
            transition: 'opacity 0.7s cubic-bezier(0.22, 1, 0.36, 1), transform 0.7s cubic-bezier(0.22, 1, 0.36, 1)',
          }}
        >
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#B8985F]/10 mb-5 md:mb-6">
            <span className="text-[12px] tracking-[1.5px] uppercase text-[#B8985F] font-semibold">About</span>
          </div>
          <h2 className="text-[28px] md:text-[38px] font-bold text-[#1A1A1A]">Built on Operational Rigor</h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[35%_65%] gap-10 lg:gap-14 items-center">
          <div
            ref={imageRef}
            style={{
              opacity: imageVisible ? 1 : 0,
              transform: imageVisible ? 'translateX(0)' : 'translateX(-32px)',
              transition: 'opacity 0.8s cubic-bezier(0.22, 1, 0.36, 1), transform 0.8s cubic-bezier(0.22, 1, 0.36, 1)',
            }}
          >
            <div className="w-full h-[340px] md:h-[440px] rounded-xl overflow-hidden border border-[#F0EDE6]">
              <img
                src="https://static.readdy.ai/image/39cbf484d561e1f62e3c6532cd56d730/0dad19790b07365661e21d8f7cf0c8ec.png"
                alt="Jerry Byang - Founder, EasyMarketPro"
                title="Jerry Byang - AI Support Automation Founder"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div>
            <div
              ref={bioRef}
              style={{
                opacity: bioVisible ? 1 : 0,
                transform: bioVisible ? 'translateY(0)' : 'translateY(28px)',
                transition: 'opacity 0.7s cubic-bezier(0.22, 1, 0.36, 1) 0.1s, transform 0.7s cubic-bezier(0.22, 1, 0.36, 1) 0.1s',
              }}
            >
              <h3 className="text-[24px] md:text-[28px] font-bold text-[#1A1A1A] mb-1">Jerry Byang</h3>
              <p className="text-[14px] md:text-[15px] text-[#B8985F] font-medium mb-6 md:mb-8">Founder, EasyMarketPro</p>

              <div className="w-[60px] h-[2px] bg-[#B8985F] mb-6 md:mb-8"></div>

              <p className="text-[14px] md:text-[16px] text-[#666] leading-[1.8] max-w-[560px] mb-8 md:mb-10">
                Jerry founded EasyMarketPro to bring operational rigor to AI implementation in customer support. With a background in systems design and enterprise software, he focuses on building agents that integrate into real workflows rather than standalone conversational tools.
              </p>
            </div>

            <div ref={cardsRef} className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
              {highlights.map((highlight, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 bg-[#FAFAF8] rounded-lg p-3.5 md:p-4 border border-[#F0EDE6]"
                  style={getItemStyle(index)}
                >
                  <div className="w-9 h-9 rounded-lg bg-[#B8985F]/10 flex items-center justify-center flex-shrink-0">
                    <i className={`${highlight.icon} text-[#B8985F] text-base`}></i>
                  </div>
                  <p className="text-[13px] md:text-[14px] text-[#555] font-medium">{highlight.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
